import { useCallback } from "react";

const useCsvDownloader = () => {
  const downloadCSV = useCallback((data, filename = "data.csv") => {
    const csvData = [];
    let headers = [...data?.header];
    const dateDataArray =
      data?.rows[0]?.[data?.chart?.column]?.split(",") || [];
    dateDataArray.forEach((_, index) => {
      headers.push(`${[data?.chart?.header]} Day (${index + 1})`);
    });
    csvData.push(headers.join(","));
    const values = [...data?.column];
    data?.rows.forEach((row) => {
      const rowArray = values.map((col) => row[col] || "");
      const dateDataValues = row?.[data?.chart?.column]?.split(",") || [];
      dateDataValues.forEach((value) => rowArray.push(value));
      csvData.push(rowArray.join(","));
    });

    const csvString = csvData.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const link = document.createElement("a");
    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return { downloadCSV };
};

export default useCsvDownloader;
